import { Button, InputGroup, MenuItem, MultiSelect, SelectMenu, CustomLabel, } from "@focus/focusUI";
import { GraphType } from "../interfaces/config";
import React, { useContext, useEffect, useState } from "react";
import { addElementToGraph, cleanElements, removeElement, setGraphTitle, setGraphType, setXValueGraph, } from "../models/graph";
import { filterItem, getFileName } from "../models/plotConfig";
import { GraphDataContext } from "../DataHandler";
import { useSelector } from "react-redux";
import { getSetting } from "@focus/services/lib/settings/selectors";
export const PreGrafosConfig = ({ config, onChange, graphId, pltVariables, selectedGraph, }) => {
    const values = Object.keys(pltVariables).sort();
    const [xValue, setXValue] = useState("");
    const { data } = useContext(GraphDataContext);
    const colorPalette = useSelector((state) => getSetting(state.settings, "chosenPalette"));
    const defaultX = values.includes("date") ? "date" : values[0];
    const ref = React.useRef(selectedGraph.id);
    useEffect(() => {
        if (selectedGraph.id !== ref.current) {
            changeXValue(selectedGraph.elements.length
                ? selectedGraph.elements[0].colX
                : defaultX);
        }
    }, [selectedGraph.id]);
    useEffect(() => {
        changeXValue(selectedGraph.elements.length ? selectedGraph.elements[0].colX : defaultX);
    }, []);
    const yValues = selectedGraph.elements.map((element) => element.colY);
    const changeXValue = (xValue) => {
        const newConfig = setXValueGraph(config, graphId, xValue, pltVariables[xValue]);
        setXValue(xValue);
        onChange(newConfig);
    };
    const isItemSelected = (item) => yValues.includes(item);
    const renderItem = (item, { modifiers, handleClick }) => {
        return (React.createElement(MenuItem, { active: modifiers.active, disabled: modifiers.disabled, icon: isItemSelected(item) ? "tick" : "blank", label: item, key: item, shouldDismissPopover: false, onClick: handleClick, text: pltVariables[item] }));
    };
    const handleGraphSelect = (graph) => {
        let newConfig;
        if (yValues.includes(graph)) {
            newConfig = removeElement(config, graphId, graph, colorPalette);
        }
        else {
            const title = pltVariables[graph];
            const fileName = getFileName(data.data);
            newConfig = addElementToGraph(config, graphId, title, xValue, graph, fileName, colorPalette);
        }
        onChange(newConfig);
    };
    const changeType = (type) => {
        const newConfig = setGraphType(config, graphId, type);
        onChange(newConfig);
    };
    const changeTitle = (title) => {
        const newConfig = setGraphTitle(config, graphId, title);
        onChange(newConfig);
    };
    const renderTag = (item) => pltVariables[item];
    const handleTagRemove = (graph) => {
        const colID = values.find((key) => pltVariables[key] === graph);
        if (graphId) {
            const newConfig = removeElement(config, graphId, colID, colorPalette);
            onChange(newConfig);
        }
    };
    const handleClear = () => {
        const newConfig = cleanElements(config, graphId);
        onChange(newConfig);
    };
    const clearButton = yValues.length > 0 ? (React.createElement(Button, { icon: "cross", minimal: true, onClick: handleClear, "data-testid": "pregrafos_clear-button" })) : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(CustomLabel, { text: "Graph title" },
            React.createElement(InputGroup, { placeholder: "Enter graph title...", value: selectedGraph.title, onChange: (ev) => changeTitle(ev.target.value) })),
        React.createElement(CustomLabel, { text: "Graph type" },
            React.createElement(SelectMenu, { options: [GraphType.Normal, GraphType.Polar], onChange: changeType, value: selectedGraph.type })),
        React.createElement(CustomLabel, { text: "X Value" },
            React.createElement(SelectMenu, { options: values, onChange: changeXValue, value: xValue, itemRenderer: (id) => pltVariables[id] })),
        React.createElement(CustomLabel, { text: "Y Values" }),
        React.createElement(MultiSelect, { popoverProps: { usePortal: false }, itemRenderer: renderItem, itemPredicate: filterItem(pltVariables), items: values, tagInputProps: {
                onRemove: handleTagRemove,
                rightElement: clearButton,
            }, onItemSelect: handleGraphSelect, tagRenderer: renderTag, selectedItems: yValues })));
};
//# sourceMappingURL=index.js.map